<template>
  <div>
    <section class="relative isolate overflow-hidden pt-24 pb-12 sm:pt-32 sm:pb-16">
      <shape-field />

      <div class="mx-auto max-w-7xl px-6 lg:px-8">
        <div
          data-animate-group
          class="mx-auto max-w-3xl text-center"
        >
          <atomic-eyebrow label="Éditeur de diaporamas" />

          <h1 class="mt-6 text-balance text-5xl font-display font-bold tracking-tight text-gray-900 sm:text-6xl">
            Vidéos, animations, QR code&nbsp;: tout ce que vos écrans peuvent afficher
          </h1>

          <p
            data-animate="fade-up"
            class="mt-6 text-pretty text-lg/8 text-gray-600"
          >
            L'éditeur Live Display réunit tout pour créer des pages d'affichage dynamique vivantes en quelques clics&nbsp;: médias, animations, comptes à rebours et informations pratiques, sans aucune compétence technique.
          </p>

          <div
            data-animate="fade-up"
            class="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4"
          >
            <button-primary
              link="/demo"
              label="Demander une démo"
              size="lg"
            />
            <button-secondary
              link="/fonctionnalites"
              label="Voir les fonctionnalités"
              size="lg"
              icon-name="ph:arrow-right"
            />
          </div>
        </div>
      </div>
    </section>

    <section
      v-for="group in editorBlockGroups"
      :id="group.slug"
      :key="group.slug"
      class="relative isolate overflow-hidden scroll-mt-24 py-16 sm:py-24"
    >
      <div class="mx-auto max-w-7xl px-6 lg:px-8">
        <atomic-section-heading
          align="center"
          :kicker="group.kicker"
          :title="group.title"
          :description="group.description"
          class="mx-auto"
        />

        <div
          data-animate-group
          class="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
        >
          <atomic-icon-card
            v-for="block in group.items"
            :key="block.title"
            v-bind="block"
            data-animate="fade-up"
          />
        </div>
      </div>
    </section>

    <section class="relative isolate overflow-hidden py-24 sm:py-32">
      <shape-field origin="right" />

      <div class="mx-auto max-w-7xl px-6 lg:px-8">
        <atomic-section-heading
          align="center"
          kicker="Développement sur mesure"
          title="Un contenu qui n'existe pas encore&nbsp;? Nous le développons pour vous"
          description="Live Display évolue avec vos besoins. Voici quelques idées que nous pouvons réaliser pour vous, et bien d'autres encore."
          class="mx-auto"
        />

        <div
          data-animate-group
          class="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
        >
          <atomic-icon-card
            v-for="block in editorOnDemandBlocks"
            :key="block.title"
            v-bind="block"
            badge="Sur demande"
            data-animate="fade-up"
          />
        </div>

        <div
          data-animate="fade-up"
          class="mt-12 flex justify-center"
        >
          <button-primary
            link="/contact"
            label="Parlez-nous de votre besoin"
            size="lg"
          />
        </div>
      </div>
    </section>

    <section-faq
      :items="faq"
      kicker="Éditeur de diaporamas"
      title="Questions fréquentes sur l'éditeur"
      description="Vidéos, comptes à rebours, QR code, animations et contenus développés sur mesure."
    />

    <section-cta />

    <section-related-links :links="relatedLinks" />
  </div>
</template>

<script setup lang="ts">
const faq = faqEditorItems

const config = useRuntimeConfig()
const env = config.public
const baseUrl = env.PUBLIC_URL.replace(/\/+$/, '')

const relatedLinks = getCrossLinks(['fonctionnalites', 'casUsages', 'demo'])

useSeo({
  title: `Vidéos, animations et QR code sur vos écrans — ${appName}`,
  description: 'Vidéos, animations, compte à rebours, QR code, horloge et météo : tout ce que l\'éditeur Live Display affiche sur vos écrans d\'affichage dynamique.',
  path: '/editeur',
  jsonLd: [
    getBreadcrumbJsonLd(baseUrl, [
      { name: 'Accueil', path: '/' },
      { name: 'Fonctionnalités', path: '/fonctionnalites' },
      { name: 'Éditeur', path: '/editeur' }
    ]),
    getFaqPageJsonLd(faq)
  ]
})
</script>
